import React from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";
import Swal from "sweetalert2";

function KontakEdit() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [formValue, setFormValue] = React.useState({
        email: "",
        alamat: "",
        jamkerja: "",
    });

    // function "fetchData"
    const fetchData = React.useCallback(async () => {
        try {
            const token = localStorage.getItem("token");
            if (!token) {
                navigate("/");
                return;
            }

            // Set token in axios headers
            axios.interceptors.request.use(
                (config) => {
                    config.headers.authorization = token;
                    return config;
                },
                (error) => {
                    return Promise.reject(error);
                }
            );

            // fetching
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/kontak/readKontakById/${id}`);
            // get response data
            const data = response.data;
            // assign response data to state "formValue"
            setFormValue({
                email: data.email,
                alamat: data.alamat,
                jamkerja: data.jamkerja,
            });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }, [id, navigate]);

    React.useEffect(() => {
        // call method "fetchData"
        fetchData();
    }, [fetchData, id]);

    const handleChange = (event) => {
        setFormValue({
            ...formValue,
            [event.target.name]: event.target.value,
        });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        // store the states in the form data
        const updatedData = {
            email: formValue.email,
            alamat: formValue.alamat,
            jamkerja: formValue.jamkerja,
        };

        try {
            // make axios put request
            const response = await axios.put(
                `${process.env.REACT_APP_API_URL}/kontak/updateKontak/${id}`,
                updatedData,
                {
                    headers: { "Content-Type": "application/json" },
                }
            );

            Swal.fire({
                title: "Success",
                text: "Data berhasil diperbarui",
                icon: "success",
            });
            navigate("/kontak");
        } catch (error) {
            console.error("Error updating data:", error);
            Swal.fire({
                title: "Error",
                text: error.response
                    ? error.response.data.message
                    : "Terjadi kesalahan saat menyimpan data.",
                icon: "error",
            });
        }
    };

    return (
        <div className="wrapper">
            <Header />
            <Navbar />
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Edit Kontak</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item text-decoration-none">
                                        <Link className="text-decoration-none" to="/">
                                            Administrasi
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active">Edit Kontak</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Form Edit Kontak</h3>
                                    </div>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            <div className="card-body">
                                                <div className="form-group">
                                                    <label>Email</label>
                                                    <input
                                                        type="email"
                                                        className="form-control"
                                                        name="email"
                                                        placeholder="Masukkan email"
                                                        onChange={handleChange}
                                                        value={formValue.email}
                                                        required
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Alamat</label>
                                                    <textarea
                                                        className="form-control"
                                                        name="alamat"
                                                        placeholder="Masukkan alamat"
                                                        onChange={handleChange}
                                                        value={formValue.alamat}
                                                        rows="3"
                                                        required
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Jam Kerja</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="jamkerja"
                                                        placeholder="Masukkan jam kerja"
                                                        onChange={handleChange}
                                                        value={formValue.jamkerja}
                                                        required
                                                    />
                                                </div>
                                                <div>
                                                    <button type="submit" className="btn btn-info">
                                                        Simpan
                                                    </button>
                                                    <Link to="/kontak">
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary ml-2"
                                                        >
                                                            Batal
                                                        </button>
                                                    </Link>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default KontakEdit;
